import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import jaJP from 'antd/locale/ja_JP';
import Login from './components/Login';
import MainLayout from './components/MainLayout';
import NewsList from './components/news/NewsList';
import NewsForm from './components/news/NewsForm';
import MeasureNewsList from './components/measureNews/MeasureNewsList';
import MeasureNewsForm from './components/measureNews/MeasureNewsForm';
import BlogsList from './components/blogs/BlogsList';
import BlogsForm from './components/blogs/BlogsForm';
import PersonalsList from './components/personals/PersonalsList';
import PersonalsForm from './components/personals/PersonalsForm';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <ConfigProvider locale={jaJP}>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }>
              <Route path="news" element={<NewsList />} />
              <Route path="news/create" element={<NewsForm />} />
              <Route path="news/edit/:id" element={<NewsForm />} />
              <Route path="measure-news" element={<MeasureNewsList />} />
              <Route path="measure-news/create" element={<MeasureNewsForm />} />
              <Route path="measure-news/edit/:id" element={<MeasureNewsForm />} />
              <Route path="blogs" element={<BlogsList />} />
              <Route path="blogs/create" element={<BlogsForm />} />
              <Route path="blogs/edit/:id" element={<BlogsForm />} />
              <Route path="personals" element={<PersonalsList />} />
              <Route path="personals/create" element={<PersonalsForm />} />
              <Route path="personals/edit/:id" element={<PersonalsForm />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;
